import {useFormik} from 'formik';
import {ChangeEvent, useMemo, useState} from 'react';
import {Link} from 'react-router-dom';

import InputOutlet from 'components/inputOutlet';
import {toEnglishDigits} from 'utilities/helper/toEnglishNumber';
import phoneNumStart09To9 from 'utilities/hooks/phoneNumStart09To9';
import CustomButton from './components/customButton';
import UseSendCode from './hooks/useSendCode';
import {initialValues} from './utilities/initialValues';
import {LoginSchema} from './utilities/loginSchema';

interface CountryPhoneCode {
  EName: string;
  PName: string;
  PCode: string;
}

const COUNTRY_PHONE_CODES: CountryPhoneCode[] = [
  {
    EName: 'iran',
    PName: 'ایران',
    PCode: '|  ۹۸+ ',
  },
  //  Future Support : Add More Countries
];

const Login = () => {
  const [selectedCountry] = useState<CountryPhoneCode>(COUNTRY_PHONE_CODES[0]);
  const {isLoading, mutate} = UseSendCode();

  const isIran = useMemo(
    () => selectedCountry.EName.toLowerCase() === 'iran',
    [selectedCountry],
  );

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: ({phoneNumber}) => {
      const formattedPhone = phoneNumStart09To9(phoneNumber, isIran);
      mutate({
        mobile: formattedPhone,
        app: 'market',
        country_code: '98',
      });
    },
  });

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = toEnglishDigits(e.target.value);
    formik.setFieldValue('phoneNumber', value);
  };

  const isPhoneInvalid =
    !!formik.errors.phoneNumber && !!formik.touched.phoneNumber;

  const isSubmitDisabled =
    isLoading || !formik.values.phoneNumber || isPhoneInvalid;

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputOutlet
        label="شماره تلفن"
        name="phoneNumber"
        type="number"
        required
        showStar={false}
        value={formik.values.phoneNumber}
        onBlur={formik.handleBlur}
        touched={!!formik.touched.phoneNumber}
        errors={formik.errors.phoneNumber?.toString()}
        onChange={handlePhoneChange}
        leftAdornment={selectedCountry.PCode}
      />

      <div className="mt-4">
        <CustomButton
          title="دریافت کد"
          isLoading={isLoading}
          disabled={isSubmitDisabled}
          classname="!py-2"
        />
      </div>

      <p className="mt-6 mb-2 text-sm font-normal text-gray-400">
        با ورود به حجره{' '}
        <Link to="/auth/rules" className="text-green-grade">
          قوانین و مقررات
        </Link>{' '}
        سایت را پذیرفته‌ام.
      </p>
    </form>
  );
};

export default Login;
